module.exports = __webpack_public_path__ + "static/media/211CS216.386b8b35.jpg";